import { render } from "./Monitor.vue?vue&type=template&id=66be3cda&scoped=true"
import script from "./Monitor.vue?vue&type=script&lang=js"
export * from "./Monitor.vue?vue&type=script&lang=js"

import "./Monitor.vue?vue&type=style&index=0&id=66be3cda&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sebastian\\Documents\\choferes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66be3cda"]])

export default __exports__